import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["component", "theme", "isClickable"];
var _templateObject, _templateObject2;
import React from 'react';
import styled from 'styled-components';
import SearchIconSvg from '../Icons/Search';
import CircularLoading from '../CircularLoading';
export var SearchIcon = styled(function (_ref) {
  var component = _ref.component,
    theme = _ref.theme,
    isClickable = _ref.isClickable,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SearchIconSvg, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: ", ";\n"])), function (_ref2) {
  var isClickable = _ref2.isClickable;
  return isClickable ? 'pointer' : 'default';
});
export var LoadingIcon = styled(CircularLoading)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  transform: none;\n  width: 16px;\n  height: 16px;\n  top: 50%;\n  right: 16px;\n  margin-top: -8px;\n"])));